import { bigCommerceEndpointTags } from '@models';
import { createApi } from '@reduxjs/toolkit/query/react';
import { cartEndpoints } from './cart-endpoints';
import { customerEndpoints } from './customer-endpoints';
import { orderEndpoints } from './order-endpoints';
import { priceListEndpoints } from './price-list-endpoints';
import { productEndpoints } from './product-endpoints';
import { shippingEndpoints } from './shipping-endpoints';
import { baseQueryWithReauth } from '@services/refreshToken.service';

// Define a service using a base URL and expected endpoints
export const bigCommerceApi = createApi({
  reducerPath: 'bigCommerceApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: bigCommerceEndpointTags,
  endpoints: (builder) => {
    return {
      ...cartEndpoints(builder),
      ...customerEndpoints(builder),
      ...orderEndpoints(builder),
      ...priceListEndpoints(builder),
      ...productEndpoints(builder),
      ...shippingEndpoints(builder),
    };
  },
});

// Export hooks for usage in functional components, which are auto-generated based on the defined endpoints
export const {
  //Cart
  useCreateCartMutation,

  // Customer
  useCreateCustomerAddressMutation,
  useDeleteCustomerAddressMutation,
  useGetCustomersQuery,
  useLazyGetCustomersQuery,
  useUpdateCustomerMutation,
  useUpdateCustomerAddressMutation,
  useResetPasswordMutation,
  useGetCustomerAttributesQuery,
  useUpdateCustomerAttributesMutation,
  useDeleteCustomerAttributeMutation,
  useUpdateEmailMutation,
  useResetFirebaseIdMutation,
  useTerminateCustomerMutation,

  // Order
  useGetOrdersByCustomerIdQuery,
  useUpdateOrderMutation,
  useIssueOrderRefundMutation,
  useGetOrderProductsQuery,
  useGetMetafieldsByOrderIdQuery,
  useCreateMetafieldForOrderMutation,
  useGetShippingAddressQuery,
  useGetOrderStatusesQuery,
  useGetOrderStatusByIdQuery,
  useGetOrderStatusQuery,
  useSyncVoucherMutation,
  useHandleInvoiceMutation,

  // Product
  useGetAllProductsQuery,
  useGetAllProductCategoriesQuery,
  useGetBulkPricingRulesQuery,
  useCreateBulkPricingRuleMutation,
  useUpdateBulkPricingRuleMutation,
  useCreateProductMutation,
  useCreateBatchOfProductsMutation,
  useUpdateProductMutation,
  useUpdateBatchOfProductsMutation,
  useDeleteProductMutation,
  useDeleteProductCustomFieldMutation,
  useGetAllProductImagesQuery,
  useUploadProductImageMutation,
  useDeleteProductImageMutation,
  useGetUploadCreateProgressQuery,
  useGetUploadUpdateProgressQuery,
  useLazyGetSyncProductQuery,

  // Price List
  useGetAllPriceListsQuery,
  useUpsertPriceListRecordsMutation,
  useDeletePriceListRecordsMutation,

  // Shipping
  useGetDeliveryFeeQuery,
} = bigCommerceApi;
